import { api } from "../../helpers/api/handler"

export const logout = () => api.post("/auth/logout/", "")
